export default __webpack_public_path__ + "static/dajana-04a872d96e1279bfce25eadf0f321484.png";